import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import { grCTMTConAdd, cpCTMTContract, tmCTMTContract, grCTMTContract, CTMTContract, liCTMTContract } from "./ConAddsAndABIs"

function MyManagersTable(){

    const [walletAddress, setWalletAddress] = useState("");
    const [tableHeading, setTableHeading] = useState("");

    const [managerId, setManagerId] = useState("");
    const [managerAdd, setManagerAdd] = useState("");
    const [myDepsCount, setMyDepsCount] = useState("");
    const [myTradingAge, setMyTradingAge] = useState("");
    const [myTokenToTrade, setMyTokenToTrade] = useState("");
    const [myTokenToTradeName, setMyTokenToTradeName] = useState("");
    const [CTMTDepsReceived, setCTMTDepsReceived] = useState("");
    const [seaWaterRetained, setSeaWaterRetained] = useState("");
    const [baseCTMT, setBaseCTMT] = useState("");
    const [myBUSDBalance, setMyBUSDBalance] = useState("");
    const [myTFTBalance, setMyTFTBalance] = useState("");
    const [myQuotation, setMyQuotation] = useState("");
    const [myTotalBUSDValue, setMyTotalBUSDValue] = useState("");
    const [myUndeclaredSuplusLoss, setMyUndeclaredSuplusLoss] = useState("");
    const [myUSLRate, setMyUSLRate] = useState("");
    const [myGrowthValue, setMyGrowthValue] = useState("");
    const [myLocalReserve, setMyLocalReserve] = useState("");
    const [myGlobalReserve, setMyGlobalReserve] = useState("");
    const [myGlobalReserveRed, setMyGlobalReserveRed] = useState("");
    const [myRedeemableGR, setMyRedeemableGR] = useState("");
    const [myRGRV, setMyRGRV] = useState("");
    const [myLocalInsurance, setMyLocalInsurance] = useState("");
    const [myAccumRetCTMT, setMyAccumRetCTMT] = useState("");

    const [myBUSDPricePerTFT, setMyBUSDPricePerTFT] = useState("");    
    const [myBUSDCostPerTFT, setMyBUSDCostPerTFT] = useState("");   

    const [myDissolutionStatus, setMyDissolutionStatus] = useState("");
    const [myDepositAcceptance, setMyDepositAcceptance] = useState("");

    const [redeemGrCTMTButton, setRedeemGrCTMTButton] = useState("");
    const [surplusLossDeclarationButton, setSurplusLossDeclarationButton] = useState("");
    const [surplusDeclarationByAnyoneButton, setSurplusDeclarationByAnyoneButton] = useState("");

    useEffect(() => {  
        
        const getWalletAddress = async () => {
            const accounts = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            const account = accounts[0]
            const accountF = account.toString()
            setWalletAddress(accountF);
        }
        
        getWalletAddress()
            .catch(console.error)

        const getManagerId = async () => {
          const role = await cpCTMTContract.managerOrProvider(walletAddress)

            if (role === "Manager") {
              setManagerAdd(walletAddress)
            } else if (role === "Provider") {
              const myManagerAdd = await cpCTMTContract.providersManager(walletAddress)            
              const myManagerAddF = myManagerAdd.toString()  
              setManagerAdd(myManagerAddF)
            } else {
              setManagerAdd("0x0000000000000000000000000000000000000000")
            }

            const data = await tmCTMTContract.managerId(managerAdd)
            const dataF = data.toString()
            setManagerId(dataF)
            
          }        



        getManagerId()
          .catch(console.error) 

        const getCTMTDepsReceived = async () => {
            const data = await tmCTMTContract.ctmtDeposits(managerId) / (10**18)
            const dataF = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setCTMTDepsReceived(dataF)

            const data1 = await tmCTMTContract.CTMTGrowthBal(managerId) / (10**18)
            const data2 = data + data1
            const data2F = data2.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setBaseCTMT(data2F)     


            }
    
        getCTMTDepsReceived()
            .catch(console.error)  

            const getSeaWaterRetained = async () => {
              const deps = await cpCTMTContract.managersCTMTDeps(managerAdd) / (10**18)
              const returned = await cpCTMTContract.manCpCTMTBurned(managerAdd) / (10**18)
              const retained = deps - returned
              const retainedF = retained.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
              setSeaWaterRetained(retainedF)
 
  
  
              }
      
              getSeaWaterRetained()
              .catch(console.error)              

        const getMyTokenToTrade = async () => {
          const tft = await tmCTMTContract.manTFT(managerId)
          const tftName = await tmCTMTContract.manTFTName(managerId)
          const str = tft.toString()
            setMyTokenToTrade(str)   
            setMyTokenToTradeName(tftName)       
          }

        getMyTokenToTrade()
          .catch(console.error)  

          const getMyTradingAge = async () => {
            const start = await tmCTMTContract.manStartDate(managerId)
            const timeNow = new Date() / 1000
            const lapsed = (timeNow - start) / (24 * 60 * 60)
            const lapsedF = lapsed.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " days"
              setMyTradingAge(lapsedF)     
            }
  
            getMyTradingAge()
            .catch(console.error)            

        const getMyBUSDBalance = async () => {
            const data = await tmCTMTContract.manBUSDBal(managerId)
            const data1 = ethers.utils.formatEther(data)
            const data2 = data / (10**18)
            const dataF1 = data2.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})  
              setMyBUSDBalance(dataF1)  
            }
    
        getMyBUSDBalance()
            .catch(console.error)  
            
        const getMyTFTBalance = async () => {
            const data = await tmCTMTContract.manTFTBal(managerId)
            const data1 = ethers.utils.formatEther(data)
            const data2 = await tmCTMTContract.manTFTBal(managerId) / (10**18)
            const dataF1 = data2.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyTFTBalance(dataF1)
            }
    
        getMyTFTBalance()
            .catch(console.error)  

        const getMyGrowthValue = async () => {
            const data = await tmCTMTContract.CTMTGrowthBal(managerId) / (10**18)
            const commaSeparated = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyGrowthValue(commaSeparated)
            }
    
            getMyGrowthValue()
            .catch(console.error)    

            const getPriceCostPerTFT = async () => {
              const tftbal = await tmCTMTContract.manTFTBal(managerId) / (10**18)
              const tCost = await tmCTMTContract.manTFTCost(managerId) / (10**18)
              const tftV = await tmCTMTContract.checkBusdValueofTFTBal(managerId) / (10**18)

              const uCost = tCost / tftbal
              const uValue = tftV / tftbal
              const uCostF = uCost.toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4})
              const uValueF = uValue.toLocaleString(undefined, {minimumFractionDigits: 4, maximumFractionDigits: 4})
                  setMyBUSDCostPerTFT(uCostF)
                  setMyBUSDPricePerTFT(uValueF)
              }
      
              getPriceCostPerTFT()
              .catch(console.error)             

            const getMyDepsCount = async () => {
              const data = await cpCTMTContract.manProvsCount(managerAdd)
              const commaSeparated = data.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})
                  setMyDepsCount(commaSeparated)
              }
      
              getMyDepsCount()
              .catch(console.error)              
            
        const getMyLocalReserve = async () => {
            const balance = await tmCTMTContract.lrCTMTBal(managerId)
            const balanceFormatted = balance / (10**18)
            const commaSeparated = balanceFormatted.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyLocalReserve(commaSeparated)
            }
    
        getMyLocalReserve()
            .catch(console.error)  

        const getMyGlobalReserve = async () => {
            const gr = await tmCTMTContract.grCTMTBal(managerId) / (10**18)
            const grr = await tmCTMTContract.grCTMTRed(managerId) / (10**18)
            const grTS = await grCTMTContract.totalSupply() / (10**18)
            const ctmtInGr = await CTMTContract.balanceOf(grCTMTConAdd) / (10**18)
            const grctmtvalue = ctmtInGr * gr / grTS
            const grf = gr.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
              setMyGlobalReserve(grf)
            const grrf = grr.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
              setMyGlobalReserveRed(grrf)              
            

            
            }
    
            getMyGlobalReserve()
            .catch(console.error)  

            const getMyRedeemableGR = async () => {
              const rGr = await tmCTMTContract.checkGlobalReserve(managerId) / (10**18)
              const grTS = await grCTMTContract.totalSupply() / (10**18)
              const ctmtInGr = await CTMTContract.balanceOf(grCTMTConAdd) / (10**18)
              const role = await cpCTMTContract.managerOrProvider(walletAddress)
              const grctmtvalue = ctmtInGr * rGr / grTS

/*              const busdB = await tmCTMTContract.manBUSDBal(managerId) / (10**18)
              const ctmtD = await tmCTMTContract.ctmtDeposits(managerId) / (10**18)
              const gwt = await tmCTMTContract.CTMTGrowthBal(managerId) / (10**18)              
              const tftV = await tmCTMTContract.checkBusdValueofTFTBal(managerId) / (10**18)
              const tav = (tftV + busdB)
              const usl = tav - ctmtD - gwt              
*/
              const commaSeparated = rGr.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyRedeemableGR(commaSeparated)

                if (ctmtInGr < grTS) {
                  const commaSeparated = grctmtvalue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                  setMyRGRV(commaSeparated)              
                } else {
                  const commaSeparated = rGr.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                  setMyRGRV(commaSeparated)                 
                }         
                
                if (rGr > 0 && role === "Manager") {
                  setRedeemGrCTMTButton(<button onClick={handleClaimGrCTMTSubmit}>Redeem</button>)
                }
              }
      
              getMyRedeemableGR()
              .catch(console.error)  

              const getMyAccumRetCTMT = async () => {
                const data = await tmCTMTContract.accumRetByMan(managerId) / (10**18)
                const commaSeparated = data.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                  setMyAccumRetCTMT(commaSeparated)
                }
        
                getMyAccumRetCTMT()
                .catch(console.error)  

        const getMyLocalInsurance = async () => {
            const liCTMTAccum = await tmCTMTContract.liCTMTBal(managerId) / (10**18)
            const liCTMTClaimed = await cpCTMTContract.claimedLiCTMT(managerAdd) / (10**18)
            const liCTMTTrans = await liCTMTContract.transferredLiCTMT(managerAdd) / (10**18)
            const liCTMTRem = liCTMTAccum - liCTMTClaimed - liCTMTTrans
            const commaSeparated = liCTMTRem.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                setMyLocalInsurance(commaSeparated)
            }
    
        getMyLocalInsurance()
            .catch(console.error)                

     

        const checkTftInBusd = async () => {
          const tftb = await tmCTMTContract.manTFTBal(managerId) / (10**18)
          const busdB = await tmCTMTContract.manBUSDBal(managerId) / (10**18)
          const ctmtD = await tmCTMTContract.ctmtDeposits(managerId) / (10**18)
          const gwt = await tmCTMTContract.CTMTGrowthBal(managerId) / (10**18)
          const grBal = await tmCTMTContract.grCTMTBal(managerId) / (10**18)
          const role = await cpCTMTContract.managerOrProvider(walletAddress)
          
          if (tftb === 0) {
            const tftV = 0
            const tav = tftV + busdB
            const usl = tav - ctmtD - gwt
            const rusl = usl + grBal
            const uslr = (usl / (ctmtD + gwt)) *100
            const ruslr = (rusl / (ctmtD + gwt)) *100
            const tftVF = tftV.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
            const tavF = tav.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const uslF = usl.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const ruslF = rusl.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const uslrF = uslr.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"   
            const ruslrF = ruslr.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"          
            setMyQuotation(tftVF) 
            setMyTotalBUSDValue(tavF)

              const dissolStat = await tmCTMTContract.isDissolved(managerId)
                if (dissolStat === false) {
                  
                    if ((usl) >= 0) {
                      setMyUSLRate(uslrF)
                      setMyUndeclaredSuplusLoss(uslF)
                    } else if ( usl < 0) {
                        if ((usl + grBal) >= 0) {
                          setMyUSLRate('0.00%')
                          setMyUndeclaredSuplusLoss('0.00')
                        } else if ((usl + grBal) < 0) {
                          const uLoss = usl + grBal
                          const uLossF = uLoss.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                          setMyUSLRate(ruslrF)
                          setMyUndeclaredSuplusLoss(uLossF)
                        }
                    }

                    if (usl > 0 && usl >= ((ctmtD + gwt) * 0.01) && role === "Manager" && busdB > usl) {
                      setSurplusLossDeclarationButton(<button type="button" onClick={handleDeclareSurplus}>Declare Profit</button>)
                    } else if (usl < 0 && (usl * -1) >= ((ctmtD + gwt) * 0.05) && role === "Manager" && ((usl + grBal) * -1) > 1 && tftb === 0) {
                      setSurplusLossDeclarationButton(<button type="button" onClick={handleDeclareLoss}>Declare Loss</button>)
                    }

                    if (usl > 0 && usl >= ((ctmtD + gwt) * 0.20) && role === "Provider") {
                      setSurplusDeclarationByAnyoneButton(<button type="button" onClick={handleDeclareSurplusByAnyone}>Declare Profit</button>)
                    }

                } else {
                  setMyUndeclaredSuplusLoss('0.00')
                  setMyUSLRate('0.00%')        }

             
          } else {
            const tftV = await tmCTMTContract.checkBusdValueofTFTBal(managerId) / (10**18)
            const tav = (tftV + busdB)
            const usl = tav - ctmtD - gwt
            const uslr = (usl / (ctmtD + gwt)) *100
            const tftVF = tftV.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
            const tavF = tav.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
            const uslF = usl.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) 
            const uslrF = uslr.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"              
            setMyQuotation(tftVF) 
            setMyTotalBUSDValue(tavF)

            if ((usl) >= 0) {
              setMyUSLRate(uslrF)
              setMyUndeclaredSuplusLoss(uslF)
            } else if ( usl < 0) {
                if ((usl + grBal) >= 0) {
                  setMyUSLRate('0.00%')
                  setMyUndeclaredSuplusLoss('0.00')
                } else if ((usl + grBal) < 0) {
                  const uLoss = usl + grBal
                  const uLossF = uLoss.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
                  setMyUSLRate(uslrF)
                  setMyUndeclaredSuplusLoss(uLossF)
                }
            }

              if (usl > 0 && usl >= ((ctmtD + gwt) * 0.01) && role === "Manager") {
                setSurplusLossDeclarationButton(<button type="button" onClick={handleDeclareSurplus}>Declare Surplus</button>)
              } else if (usl < 0 && (usl * -1) >= ((ctmtD + gwt) * 0.05) && role === "Manager" && ((usl + grBal) * -1) > 1 && tftb === 0) {
                setSurplusLossDeclarationButton(<button type="button" onClick={handleDeclareLoss}>Declare Loss</button>)
              }

              if (usl > 0 && usl >= ((ctmtD + gwt) * 0.20) && role === "Provider") {
                setSurplusDeclarationByAnyoneButton(<button type="button" onClick={handleDeclareSurplusByAnyone}>Declare Surplus</button>)
              }

          }}

          checkTftInBusd()
          .catch(console.error)     
          
          const getMyDissolutionStatus = async () => {

                const manTFt = await tmCTMTContract.manTFTName(managerId)
                if (manTFt === "Null") {
                  setMyDissolutionStatus("No token to trade yet")
                } else {
                        const dissolStat = await tmCTMTContract.isDissolved(managerId)
                        if (dissolStat === true) {    
                            setMyDissolutionStatus("Dissolved")
                        } else if (dissolStat === false) {
                            setMyDissolutionStatus("Operating")   
                        }
                 }
          }
    
            getMyDissolutionStatus()
            .catch(console.error)            

            const getMyDepositAcceptance = async () => {
              const dissolStat = await cpCTMTContract.isManagerAccDep(managerAdd)

                  if (myDissolutionStatus === "No token to trade yet") {
                      setMyDepositAcceptance("Closed")
                  } else if (myDissolutionStatus === "Dissolved") {
                      setMyDepositAcceptance("Closed")
                  } else {
                      if (dissolStat === true) {
                          setMyDepositAcceptance("Open")
                      } else if (dissolStat === false) {
                        setMyDepositAcceptance("Closed")
                      }
                  } 
              }
      
              getMyDepositAcceptance()
              .catch(console.error)   

              const getTableHeading = async () => {
                const role = await cpCTMTContract.managerOrProvider(walletAddress)
                if (role === 'Manager') {
                    setTableHeading('Details Of Trading Operation')
                } else if (role === 'Provider') {
                  const stat = "Details Of Trading Operation"
                  setTableHeading(stat)
                }
                }
        
                getTableHeading()
                .catch(console.error)   

        })         

    const handleDeclareSurplus = async (e) => {
      e.preventDefault();
      const txn = await tmCTMTContract.mds()
      await txn.wait();
      } 
  
      const handleDeclareSurplusByAnyone = async (e) => {
        e.preventDefault();
        const txn = await tmCTMTContract.pds(managerId)
        await txn.wait();
        } 

    const handleDeclareLoss = async (e) => {
      e.preventDefault();
      const txn = await tmCTMTContract.declareLoss()
      await txn.wait();
      }  

    const handleClaimGrCTMTSubmit = async (e) => {
      e.preventDefault();
      const txn = await tmCTMTContract.redeemGrCTMT()
      await txn.wait();
          }


return(
    <div>
                <h2 style={{"textAlign": "center"}}>{tableHeading}</h2><br></br>
                <p><b>Manager Address:</b> {managerAdd}</p>
                <p><b>Manager ID :</b> {managerId}</p>
                <p><b>Trading Operation Status :</b> {myDissolutionStatus}</p>
                <p><b>Supports Acceptance Status :</b> {myDepositAcceptance}</p>
                <p><b>Token For Trading :</b> {myTokenToTradeName}: {myTokenToTrade} </p> 
                  
                <table className="tableA">
                  <tbody>
                    <tr>
                    <th className="column1" style={{"width":"60%", "textAlign": "center"}}>Stats</th>
                    <th className="column2" style={{"width":"40%", "textAlign": "center"}}>Figure</th>
                    </tr>
                    <tr>
                    <td className="column1">Number of Fund Providers</td>
                    <td className="column2">{myDepsCount}</td>
                    </tr>         
                    <tr>
                    <td className="column1">Trading Age</td>
                    <td className="column2">{myTradingAge}</td>
                    </tr>                                
                    <tr>
                    <td className="column1">BUSD Received</td>
                    <td className="column2">{CTMTDepsReceived}</td>
                    </tr>
                    <tr>
                    <td className="column1">CWJC not yet returned</td>
                    <td className="column2">{seaWaterRetained}</td>
                    </tr>                    
                    <tr>
                    <td className="column1">Local Reserve</td>
                    <td className="column2">{myLocalReserve}</td>
                    </tr>  
                    <tr>
                    <td className="column1">Global Reserve</td>
                    <td className="column2">{myGlobalReserve}</td>
                    </tr>   
                    <tr>
                    <td className="column1">Global Reserve - Redeemed</td>
                    <td className="column2">{myGlobalReserveRed}</td>
                    </tr>                      
                    <tr>
                    <td className="column1">Redeemable Global Reserve <i>(Value: {myRGRV} BUSD)</i> {redeemGrCTMTButton}</td>
                    <td className="column2">{myRedeemableGR}</td>
                    </tr>                       
                    <tr>
                    <td className="column1">Local Insurance</td>
                    <td className="column2">{myLocalInsurance}</td>
                    </tr>       
                    <tr>
                    <td className="column1">CWJC Produced</td>
                    <td className="column2">{myAccumRetCTMT}</td>
                    </tr>                                                      
                    <tr>
                    <td className="column1">BUSD Balance</td>
                    <td className="column2">{myBUSDBalance}</td>
                    </tr>                                                                                               
                    <tr>
                    <td className="column1">{myTokenToTradeName} Balance</td>
                    <td className="column2">{myTFTBalance}</td>
                    </tr>
                    <tr>
                    <td className="column1">Selling Price per {myTokenToTradeName}</td>
                    <td className="column2">{myBUSDPricePerTFT}</td>
                    </tr>                      
                    <tr>
                    <td className="column1">Purchase Cost per {myTokenToTradeName}</td>
                    <td className="column2">{myBUSDCostPerTFT}</td>
                    </tr>                                        
                    <tr>
                    <td className="column1">BUSD Value Of {myTokenToTradeName}</td>
                    <td className="column2">{myQuotation}</td>
                    </tr>
                    <tr>
                    <td className="column1">Total BUSD Value of Assets Under Management</td>
                    <td className="column2">{myTotalBUSDValue}</td>
                    </tr>
                    <tr>
                    <td className="column1">Base BUSD</td>
                    <td className="column2">{baseCTMT}</td>
                    </tr>                                                                                  
                    <tr>
                    <td className="column1">Unrealized Profit or (Loss)  {myUSLRate} {surplusLossDeclarationButton}{surplusDeclarationByAnyoneButton}</td>
                    <td className="column2">{myUndeclaredSuplusLoss}</td>
                    </tr>
                  </tbody>                         
                </table>        
    </div>
  )

}


export default MyManagersTable;